import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { sendFetchRequest } from "@/utils/sendFetchRequest";
import { NetworkError } from "@/interfaces/errors/networkError";
import { Loader } from "@/components/common/loader/Loader";
import { StructuredReviewData } from "@/components/common/structuredData/StructuredData";
import { ClientReview } from "@/components/common/reviewsBlockV1/ReviewsBlock";
import { ReviewCard } from "./reviewCard/ReviewCard";
import styles from "./AllReviews.module.scss";

export type Reviews = {
  averageRating: number;
  clientReviews: ClientReview[];
};

export type AllReviewsProps = {
  reviewsInit: Reviews;
};
export const AllReviews = ({ reviewsInit }: AllReviewsProps) => {
  const intl = useIntl();

  const [isLoading, setIsLoading] = useState(false);
  const [count, setCount] = useState(8);
  const [reviews, setReviews] = useState<Reviews>({
    averageRating: 0,
    clientReviews: [],
  });

  useEffect(() => {
    setReviews({
      ...reviewsInit,
      clientReviews: reviewsInit.clientReviews.slice(0, 8),
    });
  }, [reviewsInit]);

  const getReviews = (nextCount: number) => {
    setIsLoading(true);

    sendFetchRequest(`/globalReview/v1/global-review?count=${nextCount}`)
      .then((response: Reviews) => {
        setReviews((prev) => ({
          ...prev,
          clientReviews: response.clientReviews.slice(0, nextCount),
        }));
        setIsLoading(false);
      })
      .catch((error: NetworkError<Reviews>) => {
        console.error("Error fetching reviews:", error);
        setIsLoading(false);
      });
  };

  const onShowMoreReviews = () => {
    getReviews(count + 8);
    setCount((prev) => prev + 8);
  };

  return (
    <div className={styles.allReviews}>
      <div className={styles.title}>
        {intl.formatMessage({ id: "allReviewsTitle" })}
      </div>
      <div className={styles.reviews}>
        <StructuredReviewData
          rentACarReview={reviewsInit}
          reviewsConst={undefined}
        />
        {reviews.clientReviews.map((review, index) => (
          <div key={index}>
            <ReviewCard review={review} />
            <div className={styles.reviewSeparator} />
          </div>
        ))}
      </div>
      {isLoading ? (
        <div className={styles.loaderContainer}>
          <Loader className={styles.loader} />
        </div>
      ) : (
        <div className={styles.showMore} onClick={onShowMoreReviews}>
          {intl.formatMessage({ id: "showMoreReviews" })}
        </div>
      )}
    </div>
  );
};
